export default __webpack_public_path__ + "static/media/1-1.15baddae.png";